import { SalesforcePromotionCountdown } from '~/lib/salesforce/types';

type PromotionLine = {
    c_promotionType?: { type?: string; isInPromotion?: boolean };
    c_promotionCountdown?: SalesforcePromotionCountdown[];
};

/**
 * Salesforce types the line by the promotion counting down, but withholds its discount until zero.
 * Until the line carries that discount, its price is the regular one, so it is not shown as a discount.
 */
export const getIsPromotionDiscountHeldBack = ({
    c_promotionType,
    c_promotionCountdown,
}: PromotionLine): boolean =>
    !c_promotionType?.isInPromotion &&
    (c_promotionCountdown ?? []).some(
        (promotion) =>
            promotion.isApplicableToProduct && promotion.promotionType === c_promotionType?.type,
    );
